import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { useMfaCode } from '../';

import MfaWizardStepProgress from './MfaWizardStepProgress';
import { LoginMfaForm } from '@/v5/components/organisms/AuthForm/LoginForm/LoginMfaForm';

export default function MfaWizardStepBodyTwo({
    step,
    username,
    password,
    setStep,
    authResponse,
}) {
    const {
        mfaCode,
        mfaCodeObj,
        shouldWeSwapToNextInput,
        shouldWeGoToPreviousInput,
        mfaCodeIndexDisabled,
        refs,
        hasEnteredCode,
    } = useMfaCode();

    const [mfaCodeError, setMfaCodeError] = useState(null);
    const [loading, setLoading] = useState(false);
    const isInvalid = mfaCode?.length !== 6;

    function handleCancel() {
        setStep(1);
    }

    function onLoginWithMfaCode(e) {
        e.preventDefault();
        mfaLogin();
    }

    function mfaLogin() {
        setLoading(true);
        fetch(`${import.meta.env.VITE_APP_API_URL}/AdminUser/MFA`, {
            headers: {
                authorization: `bearer ${authResponse.token}`,
                accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json;',
                'x-requestscope': '20',
            },
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            body: JSON.stringify({ code: mfaCode, username, password }),
        }).then(async (response) => {
            setLoading(false);
            const { status } = response;
            if (status === 400) {
                const data = await response.json();
                if (
                    data.message ===
                    'Unable to validate MFA sync. Please try again'
                ) {
                    setMfaCodeError(true);
                }
            } else {
                setMfaCodeError(false);
                setStep(3);
            }
        });
    }

    useEffect(() => {
        if (hasEnteredCode) {
            mfaLogin();
        }
    }, [hasEnteredCode]);

    useEffect(() => {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && isInvalid) {
                setMfaCodeError(null);
            }
        });
    }, [isInvalid]);

    return (
        <Box onSubmit={onLoginWithMfaCode}>
            <Box>
                <MfaWizardStepProgress step={step} />
            </Box>
            <Box padding="20px 0px">
                <LoginMfaForm
                    mfaCodeObj={mfaCodeObj}
                    mfaCodeError={mfaCodeError}
                    shouldWeSwapToNextInput={shouldWeSwapToNextInput}
                    shouldWeGoToPreviousInput={shouldWeGoToPreviousInput}
                    mfaCodeIndexDisabled={mfaCodeIndexDisabled}
                    refs={refs}
                    hasEnteredCode={hasEnteredCode}
                    isInvalid={isInvalid}
                    loading={loading}
                    onCancel={handleCancel}
                />
            </Box>
        </Box>
    );
}
